// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"481":"42e67692","615":"ee661489"}[chunkId] + ".chunk.js";
};